import React, {Component} from 'react';
import {Button, TextField} from '@betareader/design-system';
import {withTranslation} from 'react-i18next';

import genres from '../../../../shared/constants/genres';

export class GenresGetter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGenres: Array.isArray(props.initialValue)
        ? props.initialValue : props.initialValue ? [props.initialValue] : [],
      searchString: ''
    };
  }

  handleFilterKey = event => {
    if (event.keyCode === 13) {
      event.preventDefault();
      // Enter
      const visibleGenres = this.getVisibleGenres();
      if (visibleGenres.length === 1) {
        // if only one genre was visible, assume that the user wants to select it
        this.toggleGenre(visibleGenres[0]);
      }
    }
  };

  handleFilterChange = event => {
    this.setState({
      searchString: event.target.value
    });
  };

  toggleGenre = genre => {
    const {autoUpdate} = this.props;
    this.setState(
      prevState => {
        const newGenres = [...prevState.selectedGenres];
        const index = newGenres.findIndex(g => g === genre);
        if (index === -1) {
          newGenres.push(genre);
        } else {
          newGenres.splice(index, 1);
        }
        return {
          ...prevState,
          selectedGenres: [...newGenres],
          searchString: '' // reset search string to show all genres
        };
      },
      () => {
        if (autoUpdate) this.submit();
      }
    );
  };

  submit = () => {
    const {selectedGenres} = this.state;
    if (this.props.onUpdate) {
      const cleanedGenreList = selectedGenres.filter(
        genre => !!genre && genre.length > 0
      );
      this.props.onUpdate(cleanedGenreList);
    }
  };

  getVisibleGenres = () => {
    const {searchString} = this.state;
    const visibleGenres = genres.filter(genre =>
      genre.toLowerCase().startsWith(searchString.toLowerCase())
    );
    return visibleGenres;
  };

  // render
  render() {
    const {
      t,
      updating,
      wizardMode,
      header,
      subheader,
      autoUpdate,
      hideHeader,
      dropDown
    } = this.props;
    const {selectedGenres, searchString} = this.state;
    const visibleGenres = this.getVisibleGenres();
    return (
      <div style={{maxWidth: dropDown ? 260 : undefined}}>
        {!hideHeader && !dropDown && (
          <>
            <h2>{header || t('WhichGenresDoYouPrefer')}</h2>
            <p>{subheader || t('OnYourProfile')}</p>
          </>
        )}
        <TextField id='profile-genre-filter' label={t('Filter')}
          placeholder={t('SelectGenres')} value={searchString}
          onChange={this.handleFilterChange} onKeyDown={this.handleFilterKey} />
        <div role='group' aria-label={t('SelectGenres')}
          style={{overflow: 'auto', maxHeight: dropDown ? 220 : '50vh'}}>
          {visibleGenres.map(genre => {
            const selected = selectedGenres.includes(genre);
            return (
              <button type='button' key={genre} className='br-chip'
                aria-pressed={selected} disabled={updating}
                style={{cursor: 'pointer', background: selected ? 'var(--br-accent)' : undefined,
                  color: selected ? 'var(--br-on-accent)' : undefined}}
                onClick={() => this.toggleGenre(genre)}>
                {genre}
              </button>
            );
          })}
        </div>
        {!autoUpdate && (
          <Button style={{marginTop: 10}} disabled={updating || selectedGenres.length === 0}
            aria-busy={updating} onClick={this.submit}>
            {wizardMode ? t('Next') : t('Save')}
          </Button>
        )}
      </div>
    );
  }
}

export default withTranslation()(GenresGetter);
